import { useNavigate } from "react-router-dom";

/**
 * Inline "this feature is on a higher plan" placeholder. Used wherever a
 * scan-output capability is gated (Pricing tab, PDF export button,
 * bulk upload, etc.). Click routes to Settings → Plans.
 */
export function TierLockedCard({
  feature,
  requiredTier,
  blurb,
}: {
  feature: string;
  requiredTier: "Seller" | "Pro Seller" | "Collector";
  blurb?: string;
}) {
  const nav = useNavigate();
  return (
    <div
      style={{
        border: "1px dashed hsl(var(--ink))",
        background: "hsl(var(--paper-3, var(--cream)))",
        padding: "14px 16px",
        display: "flex",
        flexDirection: "column",
        gap: 6,
      }}
    >
      <div
        className="caps"
        style={{ fontSize: 10, letterSpacing: "0.12em", color: "hsl(var(--ink-2))" }}
      >
        {requiredTier} plan
      </div>
      <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 700, fontSize: 16 }}>
        {feature}
      </div>
      {blurb && (
        <div
          style={{
            fontFamily: "'Fraunces', 'Playfair Display', serif",
            fontSize: 12,
            color: "hsl(var(--ink-2))",
          }}
        >
          {blurb}
        </div>
      )}
      <button
        type="button"
        onClick={() => nav("/settings?tab=subs")}
        style={{
          marginTop: 6,
          alignSelf: "flex-start",
          background: "hsl(var(--ink))",
          color: "hsl(var(--cream))",
          border: "none",
          padding: "8px 12px",
          cursor: "pointer",
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 10,
          letterSpacing: "0.12em",
          textTransform: "uppercase",
        }}
      >
        Upgrade to {requiredTier} →
      </button>
    </div>
  );
}